import { slideToggle } from '@/js/components/animation/toggle';

document.addEventListener(
    'DOMContentLoaded',
    () => {
        const { body } = document;
        const jsMenuBurger = document.querySelector('.js-menu-burger');
        let winTop = 0;

        jsMenuBurger?.addEventListener('click', (e) => {
            e.preventDefault();
            if (!body.classList.contains('menu-show')) {
                winTop = window.scrollY;
                body.classList.add('menu-show');
                body.style.top = `-${winTop}px`;
                body.style.setProperty('--wintop', `${winTop}px`);
            } else {
                body.classList.remove('menu-show');
                document
                    .querySelector('html')
                    ?.classList.add('scroll-smooth-disabled');
                window.scroll(0, winTop);
                document
                    .querySelector('html')
                    ?.classList.remove('scroll-smooth-disabled');
                body.style.removeProperty('top');
                body.style.removeProperty('--wintop');

                const menuShows =
                    document.querySelectorAll('.header-menu-show');
                menuShows.forEach((item) => {
                    item.classList.remove('header-menu-show');
                });
            }
        });

        document.body.addEventListener('click', (e) => {
            const target = e.target as Element;
            if (
                (target.classList.contains('js-menu-toggle') ||
                    target.closest('.js-menu-toggle')) &&
                !target.classList.contains('btn')
            ) {
                e.preventDefault();
                const link = target.classList.contains('js-menu-toggle')
                    ? target
                    : target.closest('.js-menu-toggle');
                const linkTarget = link?.nextElementSibling;
                slideToggle(link, linkTarget, 300);
            }
        });
    },
    { once: true },
);
